// extracted by mini-css-extract-plugin
export default {"form__control":"input_form__control__8RJGG","form__input":"input_form__input__+ZA8G","form__title":"input_form__title__9yTqh"};